import { useParams } from 'react-router'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormElement, FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { valueOrDefaultValue } from '../../../../../../../../../../utils/globals/valueOrDefaultValue'
import ModalCreateEdit from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { WorkingCenterShift4DeviceModelType } from '@teinor/erp/types/company/workingCenter/workingCenterShift4Device'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { useMemo } from 'react'

interface ModalCEWorkingCenterShift4DeviceProps extends ModalEditComponentProps {
    basicData?: TwinDictionary
}

const ModalCEWorkingCenterShift4Device: React.FC<ModalCEWorkingCenterShift4DeviceProps> = ({ userPermissions, allRowData, basicData, ...rest }) => {
    const dictWorkingCenterStations = useMemo(() => {
        return dictionaryComplexFromJsonArr(basicData?.WorkingCenterStations || {})
    }, [basicData?.WorkingCenterStations])
    const { id } = useParams()
    const { t } = useTwinTranslation()
    const extraField: FormElement<keyof WorkingCenterShift4DeviceModelType>[] = []
    if (Object.keys(dictWorkingCenterStations).length) {
        extraField.push({
            name: 'WorkingCenterStationId',
            label: t('workingCenterStation', 'Puesto'),
            component: 'CustomSelectWithSearchBar',
            items: dictWorkingCenterStations,
        },)
    }
    const fields: FormRender<WorkingCenterShift4DeviceModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'manufacturer',
                    label: t('manufacturer', 'Fabricante'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'serialNumber',
                    label: t('serialNumber', 'Número de serie'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                ...extraField,
                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: id
                },
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<ModalCreateEdit fields={parsedFields} url={'/api/app/workingCenter/workingCenterShift4Device/updateWorkingCenterShift4Device'} translations={{ title: t('editShift4Device', 'Editar dispositivo Shift4'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<ModalCreateEdit fields={fields} url={'/api/app/workingCenter/workingCenterShift4Device/createWorkingCenterShift4Device'} translations={{
        title: t('createShift4Device', 'Crear dispositivo Shift4'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEWorkingCenterShift4Device